var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_543_6626",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FF0000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_543_6626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66667C0 1.19391 1.19391 0 2.66667 0H13.3333C14.8061 0 16 1.19391 16 2.66667V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667Z",
    fill: "url(#paint0_radial_543_6626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.66667C0 1.19391 1.19391 0 2.66667 0H13.3333C14.8061 0 16 1.19391 16 2.66667V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667Z",
    fill: "url(#paint1_radial_543_6626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07454 6.61385C6.89247 6.73553 6.73613 6.89193 6.61451 7.074C6.49287 7.25607 6.40829 7.46033 6.36561 7.67513C6.27942 8.10887 6.36912 8.55907 6.61497 8.92673C6.8608 9.29433 7.24274 9.54927 7.6766 9.63547C8.11047 9.7216 8.5608 9.63193 8.92853 9.38613C9.29634 9.1404 9.55133 8.7586 9.63753 8.32487C9.72373 7.89113 9.634 7.44093 9.38813 7.07327C9.14227 6.70567 8.7604 6.45072 8.32654 6.36456C7.89267 6.27839 7.44234 6.36807 7.07454 6.61385ZM11.5235 4.47601C11.3609 4.31349 11.164 4.18534 10.9483 4.10095C10.3823 3.87905 9.1474 3.88842 8.35013 3.89779C8.222 3.89779 8.1032 3.90092 8 3.90092C7.8968 3.90092 7.77487 3.90092 7.6436 3.89779C6.84633 3.88842 5.61764 3.87592 5.05174 4.10095C4.83601 4.18534 4.64218 4.31349 4.47648 4.47601C4.31078 4.63854 4.18571 4.83544 4.1013 5.0511C3.87932 5.61681 3.89183 6.85453 3.89808 7.65153C3.89808 7.77967 3.90121 7.8984 3.90121 7.99847C3.90121 8.09847 3.90121 8.2172 3.89808 8.3454C3.89183 9.14233 3.87932 10.3801 4.1013 10.9458C4.18571 11.1614 4.3139 11.3552 4.47648 11.5209C4.63905 11.6865 4.83601 11.8115 5.05174 11.8959C5.61764 12.1178 6.8526 12.1085 7.64987 12.0991C7.778 12.0991 7.8968 12.0959 8 12.0959C8.1032 12.0959 8.22513 12.0959 8.3564 12.0991C9.15367 12.1085 10.3823 12.1209 10.9483 11.8959C11.164 11.8115 11.3578 11.6834 11.5235 11.5209C11.6892 11.3583 11.8143 11.1614 11.8987 10.9458C12.1238 10.3832 12.1113 9.15173 12.1019 8.3516C12.1019 8.22033 12.0988 8.09847 12.0988 7.99533C12.0988 7.8922 12.0988 7.7734 12.1019 7.639C12.1113 6.842 12.1238 5.61057 11.8987 5.04485C11.8143 4.82919 11.6861 4.63541 11.5235 4.46976V4.47601ZM9.42567 5.86685C9.9912 6.24485 10.3833 6.83193 10.5158 7.49893C10.6483 8.166 10.5103 8.85833 10.1323 9.42367C9.945 9.7036 9.70447 9.94393 9.42434 10.1309C9.14427 10.3179 8.83 10.4479 8.4996 10.5135C7.8324 10.6459 7.13987 10.508 6.57433 10.13C6.00883 9.75247 5.61652 9.16573 5.48371 8.499C5.35091 7.83227 5.4885 7.14013 5.86619 6.57478C6.24389 6.00945 6.83074 5.61726 7.49774 5.4845C8.16467 5.35174 8.85707 5.48927 9.42253 5.86685H9.42567ZM10.3386 5.82622C10.2417 5.76059 10.1635 5.66682 10.1166 5.55743C10.0697 5.44804 10.0603 5.32927 10.0822 5.2105C10.1041 5.09173 10.1635 4.98859 10.2448 4.90421C10.3261 4.81981 10.4355 4.76356 10.5512 4.74168C10.6669 4.7198 10.7888 4.72917 10.8982 4.77606C11.0077 4.82294 11.1015 4.89795 11.1671 4.99484C11.2327 5.09173 11.2671 5.20737 11.2671 5.32615C11.2671 5.40428 11.2515 5.48242 11.2234 5.55431C11.1953 5.62619 11.1483 5.69183 11.0952 5.74809C11.0421 5.80435 10.9733 5.8481 10.9013 5.87935C10.8295 5.91061 10.7513 5.92624 10.6731 5.92624C10.5543 5.92624 10.4387 5.89186 10.3417 5.82622H10.3386ZM12.1582 12.1553C11.5735 12.7398 10.8639 12.9242 10.0635 12.9649C9.23807 13.0117 6.76194 13.0117 5.93654 12.9649C5.13616 12.9242 4.42645 12.7398 3.8418 12.1553C3.25716 11.5709 3.0727 10.8614 3.03518 10.0613C2.98828 9.23613 2.98828 6.76073 3.03518 5.93561C3.07582 5.13549 3.25716 4.42601 3.8418 3.84154C4.42645 3.25707 5.13929 3.07267 5.93654 3.03516C6.76194 2.98828 9.23807 2.98828 10.0635 3.03516C10.8639 3.07579 11.5735 3.25707 12.1582 3.84154C12.7429 4.42601 12.9273 5.13549 12.9648 5.93561C13.0117 6.7576 13.0117 9.22987 12.9648 10.0581C12.9242 10.8583 12.7429 11.5677 12.1582 12.1522V12.1553Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_543_6626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.52 18.16) rotate(-115.776) scale(21.8189 32.4532)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24392,
    stopColor: "#FF1B90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436673,
    stopColor: "#F80261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688476,
    stopColor: "#ED00C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776787,
    stopColor: "#C500E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893155,
    stopColor: "#7017FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_543_6626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.8 15.448) rotate(-57.4396) scale(9.45393 9.83347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#FF6930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#FE3B36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE3B36",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramCircle);
export default __webpack_public_path__ + "static/media/instagramCircle.932eec7116c3e71a64b2b052c2186aa7.svg";
export { ForwardRef as ReactComponent };